export default "__VITE_ASSET__CTdfdu5b__"